import {graphql} from '../gqlApp';
import type {CallFieldsFragment} from '../gqlApp/graphql';

export const CALL_FIELDS = graphql(`
	fragment CallFields on VideoCall {
		id
		connectionId
		ffCompanyId
		sellerCompanyId
		warehouseId
		status
		direction
		callbackOfCallId
		callbackUntil
		initiatedAt
		expiresAt
		acceptedAt
		startedAt
		endedAt
		endReason
		canAccept
		canJoin
		callerName
		counterpartName
		counterpartRole
		sellerCompanyName
		ffCompanyName
		warehouseName
		sourceLabel
		subjectType
		subjectId
		subjectTitle
	}
`);
export type Call = CallFieldsFragment;
export const CALL_AVAILABILITY = graphql(`
	query CallAvailability($companyId: ID!, $connectionId: ID!) {
		videoCallAvailability(companyId: $companyId, connectionId: $connectionId) {
			available
			reason
			timezone
			nextOpensAt
			availableUntil
			workStartsAt
			workEndsAt
			workingHours
			chatUrl
		}
	}
`);
export const CALL_INBOX = graphql(`
	query CallInbox($companyId: ID, $warehouseId: ID) {
		incomingVideoCalls(companyId: $companyId, warehouseId: $warehouseId) {
			...CallFields
		}
	}
`);
export const CURRENT_CALL = graphql(`
	query CurrentVideoCall($callId: ID!) {
		videoCall(callId: $callId) {
			...CallFields
		}
	}
`);
export const CALL_ACTIVITY = graphql(`
	subscription CallActivity($companyId: ID, $warehouseId: ID) {
		videoCallActivity(companyId: $companyId, warehouseId: $warehouseId) {
			callId
			warehouseId
			sellerCompanyId
		}
	}
`);
export const CALL_NOTICE = graphql(`
	query CallNotice($callId: ID) {
		videoCallNotice(callId: $callId) {
			version
			text
			accepted
		}
	}
`);
export const ACK_CALL_NOTICE = graphql(`
	mutation AckCallNotice($input: VideoCallNoticeInput!) {
		acknowledgeVideoCallNotice(input: $input)
	}
`);
export const START_CALL = graphql(`
	mutation StartVideoCall($input: InitiateVideoCallInput!) {
		initiateVideoCall(input: $input) {
			...CallFields
		}
	}
`);
export const ACCEPT_CALL = graphql(`
	mutation AcceptVideoCall($input: AcceptVideoCallInput!) {
		acceptVideoCall(input: $input) {
			...CallFields
		}
	}
`);
export const REJECT_CALL = graphql(`
	mutation RejectVideoCall($input: VideoCallActionInput!) {
		rejectVideoCall(input: $input) {
			...CallFields
		}
	}
`);
export const END_CALL = graphql(`
	mutation EndVideoCall($input: VideoCallActionInput!) {
		endVideoCall(input: $input) {
			...CallFields
		}
	}
`);
export const CALL_ADMISSION = graphql(`
	mutation CallAdmission($input: VideoCallAdmissionInput!) {
		videoCallAdmission(input: $input) {
			callId
			url
			room
			token
			expiresAt
		}
	}
`);

export const ACK_CALL_INVITATION = graphql(`
	mutation AckCallInvitation($input: VideoCallInvitationInput!) {
		acknowledgeVideoCallInvitation(input: $input)
	}
`);
